$(document).ready(function(){
setTimeout(function(){
  var bubble = $('.purchase-details__buttons .add_to_cart');
  var offset = bubble.offset();
  var top = Math.trunc(offset.top) + 'px';
  var right = ($(window).width() - (Math.trunc(offset.left) + bubble.outerWidth()) ) + 'px' // 
  $('body').css("--offset-top", '-' + top);
  $('body').css("--offset-right", right);
},100); 
  
$('.purchase-details__buttons .add_to_cart .cart-item').attr('data-cart_qty', '1'); 
  
  $('.add_to_cart').on('click',function(){
    var qty = $('.purchase-details__quantity #quantity').val();  
    //$('head').append('<style type="text/css">.purchase-details__buttons .add_to_cart .cart-item:before{ content:" '+ qty+'"}</style>');
    
   $('.purchase-details__buttons .add_to_cart .cart-item').attr('data-cart_qty', qty); 
    
    //$('.purchase-details__buttons .add_to_cart .cart-item:before').css("content", qty);
    var button = $(this);
    var cart = $('.mini_cart');
    var cartTotal = cart.attr('data-totalitems');
    var newCartTotal = parseInt(cartTotal) + 1;
    
    setTimeout(function(){
      button.addClass('sendtocart');
    },50); 
    setTimeout(function(){
      button.removeClass('sendtocart');
      cart.addClass('shake').attr('data-totalitems', newCartTotal);
      setTimeout(function(){
        cart.removeClass('shake');
      },500)
    },1000)
  }); 
  
  
  
  if ($(window).width() <= 798) {
    
    $(document).on("click",".icon-cart.mini_cart",function(event) {
        event.preventDefault();
    	window.location.href = "/cart";
    });  
    
  }
  
  
  
  
});

  $(window).resize(function() {
    var bubble = $('.purchase-details__buttons .add_to_cart');
    var offset = bubble.offset();
    var top = Math.trunc(offset.top) + 'px';
    var right = ($(window).width() - (Math.trunc(offset.left) + bubble.outerWidth()) ) + 'px'
    $('body').css("--offset-top", '-' + top);
    $('body').css("--offset-right", right);
  }); 


